import { ChangeEvent, useEffect, useRef, useState } from "react";
import { stdObject } from "../../data/types/stdObject";
import CheckIcon from "@mui/icons-material/Check";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import NOPIC from "../../assets/nopic.svg";
import { colors } from "../../data/colors";
import { useTranslation } from "react-i18next";
import BasicButton from "../BasicButton";
import { useMainContext } from "../../context/MainContext";
import { mainConfig } from "../../data/main";
import { sendData } from "../../services/sendData";
import { resumeText } from "../../utils/resumeText";

export default function ImagesListBox({ data = {} }: { data: stdObject }) {
  const { selectImage } = data;
  const { t } = useTranslation();
  const [imageList, setImageList] = useState(data.images);
  const { setMsg3, setModalData3, logoutAction, closeMsg } = useMainContext();
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setImageList(data.images);
  }, [data.images]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    if (!files[0].type.startsWith("image/")) {
      return;
    }

    const imageName = files[0].name as string;
    const reader = new FileReader();

    reader.onload = () => {
      const imagedata = reader.result as string;
      saveImage(imageName, imagedata);
    };

    reader.readAsDataURL(files[0]);

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  const saveImage = async (code: string, data: string) => {
    setMsg3("loading");
    const payloadSaveImage = { code, data };
    console.log("payloadSaveImage", payloadSaveImage);
    const responseSaveImage: stdObject = await sendData({
      endPoint: "uploadStationeryImage",
      payload: payloadSaveImage,
      logoutAction,
    });
    console.log("responseSaveImage", responseSaveImage);
    if (responseSaveImage.success && responseSaveImage.status) {
      setImageList(Object.values(responseSaveImage.images));
    }
    closeMsg(3);
  };

  const askDeleteImage = async (code: string, validate = false) => {
    if (validate) {
      setMsg3("loading");
      setModalData3({});
      const payloadDeleteImage = { code, data };
      console.log("payloadDeleteImage", payloadDeleteImage);
      const responseDeleteImage: stdObject = await sendData({
        endPoint: "deleteStationeryImage",
        payload: payloadDeleteImage,
        logoutAction,
      });
      console.log("responseDeleteImage", responseDeleteImage);
      if (responseDeleteImage.success && responseDeleteImage.status) {
        setImageList(Object.values(responseDeleteImage.images));
      }
      closeMsg(3);
    } else {
      setMsg3("custom3");
      setModalData3({
        title: t("p.wantToDeleteThisImage"),
        label: code,
        buttons: [
          {
            label: t("p.delete"),
            onClick: () => askDeleteImage(code, true),
            color: colors.red,
          },
          {
            label: t("p.cancel"),
            onClick: () => closeMsg(3),
            color: colors.darkGrey,
          },
        ],
      });
    }
  };

  return (
    <div className="modalInputsBox">
      <div
        style={{
          padding: 5,
          paddingBottom: 10,
          justifyItems: "center",
          textAlign: "center",
        }}
      >
        <input
          id="fileInput"
          ref={inputRef}
          style={{ display: "none" }}
          type="file"
          accept="image/*,.glb,model/gltf-binary"
          onChange={handleFileChange}
        />
        <label
          htmlFor="fileInput"
          className={"stdButton noSelect"}
          style={{ backgroundColor: colors.green }}
        >
          {t("p.uploadImage")}
        </label>
      </div>
      <div style={{ maxWidth: 400 }}>
        {imageList.length > 0 &&
          imageList.map((e: string, index: number) => (
            <div
              key={index}
              style={{
                padding: 5,
                width: 112,
                border: "solid 2px " + colors.grey,
                borderRadius: 5,
                float: "left",
                justifyItems: "center",
                margin: 3,
              }}
            >
              <div
                className="listImage"
                style={{ width: 100, height: 60, marginBottom: 5 }}
                onClick={() => selectImage(e)}
              >
                <img
                  src={`${mainConfig.url}/images/stationery/${e}`}
                  onError={(e: any) => (e.target.src = NOPIC)}
                  loading="lazy"
                  alt={e}
                />
              </div>
              <div>{resumeText(e)}</div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  paddingTop: 5,
                  gap: 5,
                }}
              >
                <BasicButton
                  Icon={CheckIcon}
                  color={colors.green}
                  onClick={() => selectImage(e)}
                />
                <BasicButton
                  Icon={DeleteForeverIcon}
                  color={colors.red}
                  onClick={() => askDeleteImage(e)}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
